import {EmploymentType, Gender, ReportState} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class Export {

	public genders: Gender[] = [];
	public countryCodes: string[] = [];
	public employmentTypes: EmploymentType[] = [];

	public orderIds: string[] = [];

	public reportStates: ReportState[] = [];
	public amountFrom: number | null = null;
	public amountTo: number | null = null;

	public dateFrom: string | null = null;
	public dateTo: string | null = null;

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'amount':
				//TODO: validation needed?
				return [];
			default:
				return [];
		}
	}

}
